import { AuthUserType } from "../../Actions/Types"
import { UserType, User, OTPSession } from "../../Models/Client/User"
import { Action, Reducer } from "redux"

export type UserState = User

const initialState: UserState = {
    type: UserType.unresolved,
    isResumingSession: false
}

interface UnconfirmedUserAction extends Action<AuthUserType.confirmSignup> {
    payload: { email: string; password: string }
}

interface UnverifiedUserAction extends Action<AuthUserType.verifyOTP> {
    payload: OTPSession
}

export type UserAction =
    | UnconfirmedUserAction
    | UnverifiedUserAction
    | {
          type: Exclude<
              AuthUserType,
              AuthUserType.confirmSignup | AuthUserType.verifyOTP
          >
      }

export const UserReducer: Reducer<UserState, UserAction> = (
    state = initialState,
    action
): UserState => {
    switch (action.type) {
        case AuthUserType.startSignIn:
            return state.type === UserType.anonymous
                ? { ...state, isSigningIn: true }
                : state
        case AuthUserType.verifyOTP:
            return state.type === UserType.anonymous
                ? {
                      ...state,
                      isSigningIn: false,
                      isSigningUp: false,
                      session: { ...action.payload }
                  }
                : state
        case AuthUserType.startSignUp:
            return state.type === UserType.anonymous
                ? { ...state, isSigningUp: true }
                : state
        case AuthUserType.startResumeSession:
            return state.type === UserType.unresolved
                ? { ...state, isResumingSession: true }
                : state
        case AuthUserType.signedIn:
        case AuthUserType.signedUp:
        case AuthUserType.resumedSession:
            return {
                type: UserType.member,
                isSigningOut: false
            }
        case AuthUserType.startSignOut:
            return state.type === UserType.member
                ? { ...state, isSigningOut: true }
                : state
        case AuthUserType.signedOut:
        case AuthUserType.noSession:
            return {
                type: UserType.anonymous,
                isSigningUp: false,
                isSigningIn: false
            }
        case AuthUserType.confirmSignup:
            return {
                type: UserType.unconfirmed,
                ...action.payload
            }
        default:
            return state
    }
}
